import React, { useState, useEffect } from 'react'
import { DataTable, TextInput, Button } from '@paypalcorp/pp-react'
import Fuse from 'fuse.js'

const CodeCell = (value) => {
  return <code>{value.value}</code>
}

const allRows = [
  {
    id: 'row1',
    name: {
      value: 'card',
    },
    value: {
      value: 'Credit or debit cards',
    },
  },
  {
    id: 'row2',
    name: {
      value: 'credit',
    },
    value: {
      value: 'PayPal Credit (US, UK)',
    },
  },
  {
    id: 'row3',
    name: {
      value: 'paylater',
    },
    value: {
      value:
        'Pay Later (US, UK), Pay in 4 (AU), 4X PayPal (France), Später Bezahlen (Germany)',
    },
  },
  {
    id: 'row4',
    name: {
      value: 'bancontact',
    },
    value: {
      value: 'Bancontact',
    },
  },
  {
    id: 'row5',
    name: {
      value: 'blik',
    },
    value: {
      value: 'BLIK',
    },
  },
  {
    id: 'row6',
    name: {
      value: 'eps',
    },
    value: {
      value: 'eps',
    },
  },
  {
    id: 'row7',
    name: {
      value: 'giropay',
    },
    value: {
      value: 'giropay',
    },
  },
  {
    id: 'row8',
    name: {
      value: 'ideal',
    },
    value: {
      value: 'iDEAL',
    },
  },
  {
    id: 'row9',
    name: {
      value: 'mercadopago',
    },
    value: {
      value: 'Mercado Pago',
    },
  },
  {
    id: 'row10',
    name: {
      value: 'mybank',
    },
    value: {
      value: 'MyBank',
    },
  },
  {
    id: 'row11',
    name: {
      value: 'p24',
    },
    value: {
      value: 'Przelewy24',
    },
  },
  {
    id: 'row12',
    name: {
      value: 'sepa',
    },
    value: {
      value: 'SEPA-Lastschrift',
    },
  },
  {
    id: 'row13',
    name: {
      value: 'sofort',
    },
    value: {
      value: 'Sofort',
    },
  },
  {
    id: 'row14',
    name: {
      value: 'venmo',
    },
    value: {
      value: 'Venmo',
    },
  },
]

const columns = {
  name: {
    title: 'Option',
    width: '50%',
    cellAs: CodeCell,
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  value: {
    title: 'Description',
    mobile: {
      placement: 'b3',
    },
  },
}

const options = {
  threshold: 0.4,
  keys: ['name.value', 'value.value'],
}

const fuse = new Fuse(allRows, options)

const FundingTable = () => {
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const [isLoading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const showSeeMoreBtn = rows.length < allRows.length
  const [filteredRows, setFilteredRows] = useState([])

  useEffect(() => {
    if (searchInput) {
      setFilteredRows(fuse.search(searchInput).map(({ item }) => item))
    } else {
      setFilteredRows([])
    }
  }, [searchInput])

  const handleTextChange = (e) => {
    setSearchInput(e.target.value)
  }

  const handleSeeMore = () => {
    setSearchInput('')
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      <TextInput
        name="basic"
        value={searchInput}
        label="Search table"
        labelClassName="test"
        onKeyUp={handleTextChange}
      />
      <DataTable
        description="Basic"
        rows={searchInput ? filteredRows : rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default FundingTable
